module.exports = __webpack_public_path__ + "static/media/Image@2x.c2f7cef4.png";